export default [
    {//首页
        path: '/',
        redirect: "/square",
        component: function (resolve) {
            require(['./Layout.vue'], resolve);
        },
        children: [
            {
                path: '/square',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
            {
                path: '/runway',
                component: function (resolve) {
                    require(['./creation.vue'], resolve);
                }
            },
            {
                path: '/Anime', // 风格转换
                component: function (resolve) {
                    require(['./creation.vue'], resolve);
                }
            },
            {
                path: '/Face', // 换脸
                component: function (resolve) {
                    require(['./creation.vue'], resolve);
                }
            },
            {
                path: '/favorites',
                component: function (resolve) {
                    require(['./favorites.vue'], resolve);
                }
            },
            {
                path: '/inventory',
                component: function (resolve) {
                    require(['./inventory.vue'], resolve);
                }
            },
            {
                path: '/invite',
                component: function (resolve) {
                    require(['./invite.vue'], resolve);
                }
            },
            {// 会员中心
                path: '/member',
                component: function (resolve) {
                    require(['./member.vue'], resolve);
                }
            },
            {
                path: '/mine',
                component: function (resolve) {
                    require(['./mine.vue'], resolve);
                }
            },
            {
                path: '/info',
                component: function (resolve) {
                    require(['./info.vue'], resolve);
                }
            },
            {
                path: '/reqrefund',
                component: function (resolve) {
                    require(['./reqrefund.vue'], resolve);
                }
            },
            {
                path:"/tuiguang",
                name:"tuiguang",
                meta:{showTab:true},
                component:() => import('VIEWS/square.vue')
            },
            {
                path: '/toollist',
                component: function (resolve) {
                    require(['./tool_list.vue'], resolve);
                }
            },
            {
                path: '/creation_tool',
                component: function (resolve) {
                    require(['./creation_tool.vue'], resolve);
                }
            },
        ]
    },
    {//联系我们
        path: '/contact2',
        component: function (resolve) {
            require(['./contact2.vue'], resolve);
        },

    },
    {//绘画详情
        path: '/drawDetail',
        component: function (resolve) {
            require(['./drawDetail.vue'], resolve);
        },
    },
    {//绘画详情
        path: '/loginok',
        component: function (resolve) {
            require(['./Loginsuccess.vue'], resolve);
        },
    },
    {//联系我们
        path: '/linkus',
        component: function (resolve) {
            require(['./linkus.vue'], resolve);
        },
    },
]